<template>
  <div>
    <h2 class="step-name">Preventive Animal Health and Vaccination</h2>

    <div class="step-section">
      <h3 class="text-left">Lepto Products Purchased</h3>
      <div v-if="getChartData('lepto_purchases').length > 0 ">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Purchase Date</th>
              <th>Farm</th>
              <th>Stock Code - Name</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lp, index) in getChartData('lepto_purchases')" :key="'lepto_'+index">
              <td class="text-left">{{ lp["Purchase Date"] }}</td>
              <td class="text-left">{{ lp["Farm"] }}</td>
              <td class="text-left">{{ lp["Stock Code - Name"] }}</td>
              <td class="text-left">{{ lp["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p class="text-left">No Results</p>
      </div>
    </div>

		<div class="step-section text-left">
			<h3 class="text-left">
				<span class="form-group">
					Lepto Vaccination
					<comments field-name="heading_lepto_vaccination" :isReadOnly="isReadOnly"></comments>
				</span>
			</h3>

		<br>
			<div v-if="getFieldValue('winter_lepto_comment')">
				<span>
					<strong>Winter Consult Comments:</strong>
					{{getFieldValue('winter_lepto_comment')}}
				</span>
			</div>
		<hr>

			<div class="alert alert-info">
				The data below comes from the previous winter consult. This data and
				any changes made here will be available in the next winter consult.
			</div>

			<div class="row">
				<div class="col-md-3"><strong>Calves</strong></div>
				<div class="col-md-3"><strong>Month</strong></div>
				<div class="col-md-3"><strong>Vax Type</strong></div>
				<div class="col-md-3"><strong>Est. number of animals</strong></div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input label="" placeholder="1st Shot" :disabled="true" :show-input-box="false"> </text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="first_shot_month"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="first_shot_vax_type"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input
						label=""
						field-name="first_shot_est_number_animals"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input label="" placeholder="2nd Shot" :disabled="true" :show-input-box="false"> </text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="second_shot_month"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="second_shot_vax_type"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input
						label=""
						field-name="second_shot_est_number_animals"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input label="" placeholder="3rd Shot" :disabled="true" :show-input-box="false"> </text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="third_shot_month"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="third_shot_vax_type"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input
						label=""
						field-name="third_shot_est_number_animals"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>
			<h4>Herds and Heifers</h4>
			<div class="row">
				<div class="col-md-3"><strong>Animal</strong></div>
				<div class="col-md-3"><strong>Month</strong></div>
				<div class="col-md-3"><strong>Vax Type</strong></div>
				<div class="col-md-3"><strong>Est. number of animals</strong></div>
			</div>
			<div class="row" v-for="farm in FARMS" :key="`aniamlrow-${farm.id}`">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input label="" :placeholder="farm.farm_label" :disabled="true" :show-input-box="false"> </text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						:field-name="`animallmdata_${farm.id}-month`"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						:field-name="`animallmdata_${farm.id}-vax_type`"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input
						label=""
						:field-name="`animallmdata_${farm.id}-est_number_animals`"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input label="" placeholder="Heifers" :disabled="true" :show-input-box="false"> </text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="heifers_month"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="heifers_vax_type"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input label="" field-name="heifers_est_number_animals" :disabled="isReadOnly" :show-input-box="false">
					</number-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-3">
					<span class="form-group"><label>  </label></span>
					<text-input
						label=""
						field-name="other_animal_name"
						placeholder="Other (Beef, Bull, etc)"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					>
					</text-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="other_animal_month"
						:disabled="isReadOnly"
						:options="monthOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<select-input
						label=""
						field-name="other_animal_vax_type"
						:disabled="isReadOnly"
						:options="vaxTypeOptions"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-3">
					<number-input
						label=""
						field-name="other_animal_est_number_animals"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<select-input
						label="Programme Type?"
						field-name="lepto_vax_program"
						:disabled="isReadOnly"
						:options="[
							{ value: 'Vet Vaccinated', display: 'Vet Vaccinated' },
							{ value: 'Lepto QA', display: 'Lepto QA' },
							{ value: 'Lepto QA Vet Vaccinated', display: 'Lepto QA Vet Vaccinated' },
							{ value: 'Does not vaccinate', display: 'Does not vaccinate' },
						]"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-4">
					<select-input
						label="Vaccination Completed in?"
						field-name="lepto_vax_completed_in"
						:disabled="isReadOnly"
						:options="[
							{ value: 'May', display: 'May' },
							{ value: 'December', display: 'December' },
							{ value: 'Not Applicable', display: 'Not Applicable' },
						]"
						:show-input-box="false"
					>
					</select-input>
				</div>
				<div class="col-md-4">
					<number-input
						label="Numbers of Pigs on Farm?"
						field-name="pigs_on_farm"
						:disabled="isReadOnly"
						:show-input-box="false"
					>
					</number-input>
				</div>
			</div>
		</div>

    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">
        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <fieldset>
            <legend>Salmonella Vaccination</legend>
            <radio-input label="Salmonella Vaccination?"
                         :field-name="`farm_${farm.id}-wants_salmonella_vaccine`"
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>


            <p>Select Salmonella vaccine from drug allocations below</p>

            <check-box label="First time user"
                       :disabled="isReadOnly"
                       :field-name="`farm_${farm.id}-is_first_time_salmonella_vax_user`">
            </check-box>

            <check-box label="Continuous user"
                       :disabled="isReadOnly"
                       :field-name="`farm_${farm.id}-is_continuous_salmonella_vax_user`">
            </check-box>

          </fieldset>

          <fieldset>
            <legend>
              <h3 class="form-group">
                Scour Vaccination
              </h3>
              <small>
                Scour Vaccine Clinical Notes
                <comments :field-name="`farm_${farm.id}-heading_scour_vaccination`"  :isReadOnly="isReadOnly"></comments>
              </small>
              <br>
              <small style="font-size: .7em;">
                Allocate Scour Vaccine using Drug Allocation Cart below
              </small>
            </legend>

            <label for="">
              Confirmed Scour Vaccine Order to Retail
              <i class="glyphicon glyphicon-envelope"
                 v-tooltip="'Email might be generated'"
                 title="Email might be generated">
              </i>
            </label>

            <date-input label="Date required"
                        :field-name="`farm_${farm.id}-scour_vaccine_req_date`"
                        :disabled="isReadOnly">
            </date-input>


            <text-area label="Order notes to Retail"
                       :field-name="`farm_${farm.id}-scour_vaccine_product_and_doses_req`"
                       :disabled="isReadOnly">
            </text-area>

          </fieldset>

        </div>

      </div>
    </div>

    <div class="step-section alert alert-success">
			<label>
				This field is optional
			</label>
      <radio-input label="Interested in transition minerals?"
                   field-name="wants_agvance_transition_salts"
                   :addComment="true"
                   :addEmailNotification="true"
                   :choices="[
                              {value: 'Yes', display: 'Yes'},
                              {value: 'No', display: 'No'},
                              {value: 'Maybe', display: 'Maybe'},
                              ]"
                   :disabled="isReadOnly">
      </radio-input>

    </div>

		

    <drug-allocation-cart :farms="getFieldValue('FARMS')" :drugs="getFieldValue('DRUGS')"></drug-allocation-cart>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './current_mastitis_situation/DrugAllocationCart'

export default {
  name: 'PreventiveHealthAndVacination',
  mixins: [ baseComponent ],
  // mounted() {
  //   this.prepopulateLeptoFields()
  // },
  components: {
    DrugAllocationCart,
  },
  computed: {
    minDate: function () {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return `${yyyy}-${mm}-${dd}`;
    },
    vaxTypeOptions: function () {
      return ['7in1', 'Plain lepto', 'Lepto 4 way'].map((vax) => {
        return { value: vax.toLowerCase(), display: vax }
      })
    },
    monthOptions: function () {
      return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ].map((month) => {
        return { value: month.toLowerCase(), display: month }
      })
    }
  },
  methods: {
    prepopulateLeptoFields: function () {
			// dcc lepto: https://basecamp.com/2638249/projects/7913146/todos/491058748
      // Prepopulate calves
      let calvesEstNumberFields = [
        'first_shot_est_number_animals',
        'second_shot_est_number_animals',
        'third_shot_est_number_animals',
      ]
      if (!calvesEstNumberFields.every((field) => this.getFieldValue(field))) {
        let estNumberCalves = this.FARMS.map((farm) => this.prefixedField('r1', farm.id))
          .map((field) => this.getFieldValue(field, 'AnimalNumbers') || 0)
          .reduce((partialSum, a) => partialSum + a, 0)
        for (let field of calvesEstNumberFields) {
          if ([null, undefined].includes(this.getFieldValue(field))) {
            if (estNumberCalves && estNumberCalves > 0) {
              this.setFieldValue({
                fieldName: field,
                value: estNumberCalves,
              })
            }
          }
        }
      }

      for (let farm of this.FARMS) {
        let field = this.prefixedField('est_number_animals', farm.id, 'animallmdata')
        if (farm.id && [null, undefined].includes(this.getFieldValue(field))) {
          let estNumberHerd =
            this.getFieldValue(this.prefixedField('cows_wintered_incl_r2', farm.id), 'AnimalNumbers')
            // - this.getFieldValue(this.prefixedField('r2', farm.id), 'AnimalNumbers')
          if (estNumberHerd && estNumberHerd > 0) {
            this.setFieldValue({
              fieldName: field,
              value: estNumberHerd,
            })
          }
        }
      }

      let estNumberHeifers = this.FARMS.map((farm) => this.prefixedField('r2', farm.id))
        .map((field) => this.getFieldValue(field, 'AnimalNumbers') || 0)
        .reduce((partialSum, a) => partialSum + a, 0)

      if ([null, undefined].includes(this.getFieldValue('heifers_est_number_animals'))) {
        if (estNumberHeifers && estNumberHeifers > 0) {
          this.setFieldValue({
            fieldName: 'heifers_est_number_animals',
            value: estNumberHeifers,
          })
        }
      }
    },
    toggleNotifications: function() {

      this.setEmailNotification({
        slug: 'wants-agvance-transition-salts',
        value: this.getFieldValue('wants_agvance_transition_salts', this.$options.name) == 'Yes'
      })

      this.setEmailNotification({
        slug: 'scour-vaccine-preventive-animal-health-and-vaccination',
        value: this.getFieldValue('FARMS', this.$options.name).some(farm => this.getFieldValue(`farm_${farm.id}-scour_vaccine_req_date`, this.$options.name) || this.getFieldValue(`farm_${farm.id}-scour_vaccine_product_and_doses_req`, this.$options.name))
      })
    },
  },
};
</script>

<style scoped>
.flowchart {
  font-size: 1.2em;
}
</style>
